/**
 * Accordion functionality
 */
export function initAccordion() {
  const triggers = document.querySelectorAll('.accordion-trigger');

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      const contentId = trigger.getAttribute('aria-controls');
      const content = document.getElementById(contentId);

      // Close all other items (single mode)
      const accordion = trigger.closest('.accordion');
      if (accordion) {
        accordion.querySelectorAll('.accordion-trigger').forEach((otherTrigger) => {
          if (otherTrigger !== trigger) {
            otherTrigger.setAttribute('aria-expanded', 'false');
            const otherId = otherTrigger.getAttribute('aria-controls');
            const otherContent = document.getElementById(otherId);
            if (otherContent) {
              otherContent.setAttribute('aria-hidden', 'true');
            }
          }
        });
      }

      // Toggle current item
      trigger.setAttribute('aria-expanded', !expanded);
      if (content) {
        content.setAttribute('aria-hidden', expanded);
      }
    });
  });
}